import { useEffect } from 'react';

/** Locks the site to dark mode — no theme switching. */
export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.add('dark');
    try { localStorage.setItem('isbm-theme', 'dark'); } catch (_) {}
  }, []);

  return children;
}
